import { render, staticRenderFns } from "./DiscountsListTable.vue?vue&type=template&id=296de609&scoped=true"
import script from "./DiscountsListTable.vue?vue&type=script&lang=js"
export * from "./DiscountsListTable.vue?vue&type=script&lang=js"
import style0 from "./DiscountsListTable.vue?vue&type=style&index=0&id=296de609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296de609",
  null
  
)

export default component.exports